import { cn } from "@/lib/utils";

export interface PaginationDotsProps {
  total: number;
  currentIndex: number;
  onDotClick: (index: number) => void;
  className?: string;
  dotClassName?: string;
  activeDotClassName?: string;
  inactiveDotClassName?: string;
}

/**
 * Pagination dots component for carousels/sliders
 * Shows visual indicator of current position and allows navigation
 */
export const PaginationDots = ({
  total,
  currentIndex,
  onDotClick,
  className,
  dotClassName,
  activeDotClassName,
  inactiveDotClassName,
}: PaginationDotsProps) => {
  if (total <= 1) return null;

  return (
    <div className={cn("flex justify-center gap-2 mt-4", className)}>
      {Array.from({ length: total }, (_, index) => {
        const isActive = index === currentIndex;
        return (
          <button
            key={index}
            onClick={(e) => {
              e.stopPropagation();
              onDotClick(index);
            }}
            className={cn(
              "rounded-full transition-all cursor-pointer hover:opacity-80",
              // Mobile: smaller dots, round inactive (h-2 w-2), elongated active (w-6)
              // Desktop: larger dots, wider inactive (h-3 w-5), elongated active (w-10)
              isActive ? "h-2 w-6 md:w-10 bg-cede-primary" : "h-2 w-2 md:w-4 bg-white/30",
              dotClassName,
              isActive ? activeDotClassName : inactiveDotClassName,
            )}
            aria-label={`Go to slide ${index + 1}`}
          />
        );
      })}
    </div>
  );
};
